import { MDBCol, MDBRow, } from "mdb-react-ui-kit";

export default function CssfFooter() {
    return (
        <footer className="cv-footer-cssf" style={ { fontSize: "10px" } }>
            <MDBRow className="mr-5 pt-4" style={ { marginLeft: "12%" } }>
                <MDBCol style={ { marginTop: "33px", color: "black" } }>
                    <p style={ { margin: 0, fontSize: "11px", fontFamily: "Verdana, sans-serif", color: "#006D88" } }>
                        <strong>Commission de Surveillance du Secteur Financier</strong>
                    </p>
                    <p style={ { margin: 0, fontSize: "11px", fontFamily: "Verdana, sans-serif", color: "#006D88" } }>
                        283, route d’Arlon – L-2991 Luxembourg – (+352) 26 25 1-1 – direction@cssf.lu – TVA LU17756005
                    </p>
                    <p style={ { margin: 0, fontSize: "11px", fontFamily: "Verdana, sans-serif", color: "#006D88" } }>
                        <strong>www.cssf.lu</strong>
                    </p>
                </MDBCol>
            </MDBRow>
        </footer>
    );
}
